<template>
  <div class="select-sbs-project">
    <!-- Информация о ЖК и типе проекта -->
    <div v-if="data?.resident_name || data?.project_type_name" class="project-info-section">
      <div v-if="data?.resident_name" class="info-item">
        <span class="info-label">ЖК:</span>
        <span class="info-value">{{ data.resident_name }}</span>
      </div>
      <div v-if="data?.project_type_name" class="info-item">
        <span class="info-label">Тип проекта:</span>
        <span class="info-value">{{ data.project_type_name }}</span>
      </div>
    </div>

    <!-- Поиск -->
    <div class="search-section">
      <q-input
        v-model="searchText"
        outlined
        dense
        placeholder="Поиск по ЖК, типу проекта, ID, GUID или связям с УСП..."
        clearable
        autofocus
        class="search-input"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>

    <!-- Таблица проектов -->
    <div class="table-section">
      <q-linear-progress v-if="loading" indeterminate />
      
      <div v-else-if="filteredProjects.length === 0" class="empty-state">
        <q-icon name="folder_off" size="64px" color="grey-5" />
        <div class="empty-text">Проекты не найдены</div>
      </div>

      <q-table
        v-else
        :rows="filteredProjects"
        :columns="projectColumns"
        row-key="project_id"
        flat
        bordered
        :rows-per-page-options="[20, 50, 100]"
        :pagination="pagination"
        @update:pagination="pagination = $event"
        class="projects-table"
        virtual-scroll
        :virtual-scroll-item-size="48"
      >
        <template v-slot:body-cell-project_id="props">
          <q-td :props="props">
            <div class="id-cell">
              {{ props.value }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-resident_name="props">
          <q-td :props="props">
            <div class="name-cell">
              {{ props.value }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-project_type_name="props">
          <q-td :props="props">
            <div class="name-cell">
              {{ props.value }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-project_guid="props">
          <q-td :props="props">
            <div class="guid-cell">
              {{ props.value || '-' }}
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-usp_check_link_text="props">
          <q-td :props="props">
            <div class="link-status-cell">
              {{ props.value || '-' }}
            </div>
          </q-td>
        </template>
        
        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <q-btn
              label="Выбрать"
              color="primary"
              size="sm"
              unelevated
              @click="selectProject(props.row)"
              class="select-btn"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { getSbsProjectListForModal } from "@/views/ProjectsEntry/services";

export default {
  name: "select-sbs-project",
  props: ["data", "closeModal"],
  data() {
    return {
      loading: false,
      searchText: "",
      allProjects: [],
      pagination: {
        rowsPerPage: 20
      },
      projectColumns: [
        {
          name: 'project_id',
          label: 'ID проекта',
          field: 'project_id',
          align: 'left',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          name: 'resident_name',
          label: 'ЖК',
          field: 'resident_name',
          align: 'left',
          sortable: true,
          style: 'width: 20%;'
        },
        {
          name: 'project_type_name',
          label: 'Тип проекта',
          field: 'project_type_name',
          align: 'left',
          sortable: true,
          style: 'width: 15%;'
        },
        {
          name: 'project_guid',
          label: 'Project GUID',
          field: 'project_guid',
          align: 'left',
          sortable: false,
          style: 'width: 18%;'
        },
        {
          name: 'usp_check_link_text',
          label: 'Связи с УСП',
          field: 'usp_check_link_text',
          align: 'left',
          sortable: false,
          style: 'width: 20%;'
        },
        {
          name: 'actions',
          label: 'Действия',
          field: 'actions',
          align: 'center',
          style: 'width: 120px;'
        }
      ],
    };
  },
  computed: {
    filteredProjects() {
      if (!this.searchText) {
        return this.allProjects;
      }
      
      const query = this.searchText.toLowerCase();
      return this.allProjects.filter(project => {
        return (
          project.resident_name?.toLowerCase().includes(query) ||
          project.project_type_name?.toLowerCase().includes(query) ||
          project.project_id?.toString().includes(query) ||
          project.project_guid?.toLowerCase().includes(query) ||
          project.usp_check_link_text?.toLowerCase().includes(query)
        );
      });
    },
  },
  async mounted() {
    await this.loadProjects();
  },
  methods: {
    async loadProjects() {
      this.loading = true;
      const res = await getSbsProjectListForModal();
      this.allProjects = res || [];
      this.loading = false;
    },
    selectProject(project) {
      if (this.data?.onSelect) {
        this.data.onSelect(project);
      }
      this.$nextTick(() => {
        if (this.closeModal) {
          this.closeModal();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.select-sbs-project {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: white;
  overflow: hidden;
}

.project-info-section {
  flex-shrink: 0;
  display: flex;
  gap: 24px;
  padding: 12px 16px;
  background-color: #F2F5F8;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-size: 14px;
  font-weight: 600;
  color: #666;
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #373D48;
}

.search-section {
  flex-shrink: 0;
}

.search-input {
  font-size: 16px;

  :deep(.q-field__control) {
    height: 52px;
  }
}

.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #999;
  flex: 1;
  min-height: 300px;
}

.empty-text {
  margin-top: 16px;
  font-size: 16px;
  color: #666;
}

.projects-table {
  flex: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  :deep(.q-table__container) {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.q-table__top),
  :deep(.q-table__bottom) {
    flex-shrink: 0;
  }

  :deep(.q-table__middle) {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  :deep(thead tr th) {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
    font-weight: 600;
    font-size: 14px;
    padding: 12px 16px;
  }

  :deep(tbody tr) {
    &:hover {
      background-color: #f9f9f9;
    }
  }

  :deep(tbody td) {
    font-size: 14px;
    padding: 12px 16px;
  }
}

.id-cell {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  font-weight: 600;
  color: #1976d2;
}

.name-cell {
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}

.parent-cell {
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
  color: #666;
  font-size: 13px;
}

.guid-cell {
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #1976d2;
  word-break: break-all;
}

.link-status-cell {
  font-size: 12px;
  color: #555;
  word-break: break-word;
  white-space: normal;
  line-height: 1.4;
}

.select-btn {
  min-width: 110px;
  font-weight: 500;
  padding: 8px 16px;
}
</style>

